import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Grid, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { MRT_Row } from "material-react-table";
import { useState } from "react";
import "react-multi-date-picker/styles/colors/green.css";
import { DdStorePerformanceResponse } from "../../../../app/models/responseModels/DdStorePerformanceResponse";
import EditStoreModal from "./EditStoreModal";
import RoutesPerStore from "./route/RoutesPerStore";

function a11yProps(index: number) {
  return {
    id: `horizotal-tab-${index}`,
    "aria-controls": `horizotal-tabpanel-${index}`,
  };
}

// type used in TabPanel
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

// Tab panel reusable component
function TabPanel(props: Readonly<TabPanelProps>) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`horizotal-tabpanel-${index}`}
      aria-labelledby={`horizotal-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingX: 3, paddingBottom: 3 }}>{children}</Box>
      )}
    </div>
  );
}
type ClientStoreActionsArgs = {
  rowData: MRT_Row<DdStorePerformanceResponse>;
  close: any;
  startDateP: any;
  endDateP: any;
  clientId: number;
  clientName: string;
  onCompleted: CallableFunction;
};

const ClientStoreActions = (props: ClientStoreActionsArgs) => {
  const [value, setValue] = useState(0);
  return (
    <>
      <Grid
        container
        item
        alignItems="center"
        justifyContent="space-between"
        paddingTop={2}
      >
        <Typography variant="h4" component="h1">
          {props.clientName} Store Actions:
        </Typography>
        <IconButton
          onClick={() => {
            props.close(false);
            props.onCompleted();
          }}
        >
          <CloseRoundedIcon sx={{ color: "primary.secondary" }} />
        </IconButton>
      </Grid>
      <Tabs
        orientation="horizontal"
        variant="fullWidth"
        value={value}
        onChange={(e, v) => setValue(v)}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="General" {...a11yProps(0)} />
        <Tab label="Associated Routes" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Box paddingTop={2}>
          <EditStoreModal
            row={props.rowData}
            clientIdArg={props.clientId}
            clientNameArg={props.clientName}
            closeModal={props.close}
            onCompleted={props.onCompleted}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RoutesPerStore
          clientId={props.clientId}
          storeId={props.rowData.original.id}
          startDate={props.startDateP}
          endDate={props.endDateP}
        />
      </TabPanel>
    </>
  );
};
export default ClientStoreActions;
